<template>
  <div class="card-title">
    <img src="@/assets/border-leaf.png" alt="" class="border-leaf border-t-l">
    <img src="@/assets/border-leaf.png" alt="" class="border-leaf border-b-r">
    <span>{{title}}</span>
  </div>
</template>

<script>
  export default {
    name: 'x-title',
    props: ['title'],
    data () {
      return {

      }
    }
  }
</script>

<style scoped>
  .card-title{
    color: #cf5600;
    position: relative;
    border-radius: 6px;
    border: solid #ed7457 4px;
    width: 116px;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    padding: 6px 0;
    margin: 0 auto;
  }
  .border-leaf{
    width: 32px;
    position: absolute;
  }
  .border-t-l {
    top: -10px;
    left: -15px;
    transform: rotateZ(140deg);
  }
  .border-b-r {
    bottom: -10px;
    right: -15px;
    transform: rotateZ(-40deg);
  }
</style>
